const SITE_ORIGIN = "https://www.olzoom.com";

export const GUIDE_POSTS = [
  {
    slug: "naver-shopping-rank-up",
    title: "네이버 매출 상승의 기본, 네이버 매출 상승하는 방법",
    description:
      "네이버 쇼핑 순위 상승은 키워드를 검색했을 때 상품(플레이스)이 위에 뜨는 것을 말합니다.유입플과 리워드의 차이, 그리고 실제 사용자 방문이 필요한 이유를 정리했습니다.",
    keywords:
      "네이버 쇼핑 순위 상승, 네이버 쇼핑 순위 올리는 방법, 스마트스토어 순위, 리워드, 유입플, 네이버 쇼핑 매출 올리는 방법",
    publishedAt: "2026-09-16",
    sections: [
      {
        heading: "검색했을 때 상품(플레이스)이 위에 떠야 합니다",
        paragraphs: [
          "구매자들이 키워드를 검색했을 때 상품(플레이스)이 위에 보이는 것이 매출 상승의 기본 조건입니다.",
          "네이버 스마트스토어에서 키워드를 검색해 상품을 상단에 노출하려면, 유입플과 리워드를 씁니다.",
          "둘 다 상품 페이지로 들어오는 방문(트래픽)을 만들지만, 만드는 방식이 다릅니다.",
        ],
      },
      {
        heading: "유입플과 리워드",
        paragraphs: [
          "유입플은 프로그램으로 방문자, 즉 트래픽을 강제로 올리는 방식입니다. 사람이 검색해서 들어온 방문이 아니라, 방문 횟수 자체를 만들어 넣는 쪽에 가깝습니다.",
          "리워드는 실제 사용자가 리워드 앱(캐시플랜, 토스 등)에서 해당 상품 페이지를 방문하면 포인트를 받는 방식입니다. 즉 방문의 주체가 프로그램이 아니라 사용자입니다.",
        ],
      },
      {
        heading: "유입플만으로는 순위가 오르지 않습니다",
        paragraphs: [
          "유입플은 최근 네이버 보안 강화로 위험성이 커지고 있습니다. 프로그램을 이용해 방문을 넣는 방식은, 순위 상승에 도움이 되기보다 부담이 될 수 있습니다.",
          "유입플을 많이 넣는다고 순위가 올라가는 것도 아닙니다.",
        ],
      },
      {
        heading: "리워드를 써야하는 이유",
        paragraphs: [
          "검색 결과 상위에 뜨려면 리워드를 적극적으로 써야합니다.",
          "실제 사용자가 그 키워드와 연결된 상품 페이지를 찾아 들어오는 방문이 반복되어야, 상품이 위에 보일 자리가 생깁니다.",
          "한 번에 숫자만 키우기보다, 판매가 감당할 수 있는 범위에서 사용자 방문이 이어지는 편이 자연스럽습니다.",
        ],
      },
      {
        heading: "올려줌은 리워드로 진행합니다",
        paragraphs: [
          "올려줌은 자사 앱과 대기업 앱을 통해, 실제 사용자가 참여하는 고품질 리워드를 기반으로 광고를 진행합니다.",
          "프로그램으로 트래픽을 넣는 유입플이 아니라, 사용자가 상품 페이지를 방문하는 방식입니다.",
          "목표 키워드, 유입 키워드, 하루 유입 수, 진행 기간을 직접 정해 간편히 직접 등록할 수 있습니다.",
        ],
      },
    ],
  },
  {
    slug: "smartstore-product-top-exposure",
    title: "스마트스토어 상품 상위 노출 방법",
    description:
      "스마트스토어 상품을 네이버 쇼핑에서 상위에 노출하려면 상품 정보 최적화, 리뷰·반응 지표, 광고와 실제 검색 유입을 함께 설계해야 합니다. 상위 노출 실전 순서와 올려줌 리워드가 필요한 이유를 정리했습니다.",
    keywords:
      "스마트스토어 상위 노출, 스마트스토어 상품 상위 노출 방법, 네이버 쇼핑 상위 노출, 스마트스토어 순위 올리는 방법, 네이버 쇼핑 검색 노출, 리워드 마케팅",
    publishedAt: "2026-09-28",
    sections: [
      {
        heading: "상위 노출이 매출을 가르는 이유",
        paragraphs: [
          "스마트스토어 상품이 아무리 좋아도, 네이버 쇼핑에서 검색했을 때 보이지 않으면 구매로 이어지기 어렵습니다.",
          "상위 노출은 단순한 노출 확대가 아니라, 구매 의사가 있는 고객이 키워드를 검색한 순간에 상품을 발견하게 만드는 일입니다.",
          "그래서 상품 등록만으로 끝내기보다, 검색에 잡히는 정보와 실제 반응 데이터를 함께 쌓는 관점이 필요합니다.",
        ],
      },
      {
        heading: "네이버가 보는 세 가지 기준",
        paragraphs: [
          "검색 순위는 보통 적합도, 인기도, 신뢰도 흐름으로 이해하면 정리하기 쉽습니다.",
          "적합도는 검색어와 상품명·카테고리·속성이 얼마나 잘 맞는지를, 인기도는 클릭·찜·판매·리뷰 같은 반응을, 신뢰도는 가이드라인 준수와 스토어 운영 품질을 봅니다.",
          "한 가지만 잘해서는 한계가 있고, 카테고리마다 가중치도 달라질 수 있어 상위 상품의 구성 방식을 참고하는 편이 안전합니다.",
        ],
      },
      {
        heading: "상품명·이미지·카테고리부터 맞추기",
        paragraphs: [
          "네이버 쇼핑 검색에서 상품명은 가장 먼저 읽히는 신호입니다. 브랜드, 핵심 키워드, 부가 정보를 자연스럽게 앞에 두고, 과장 문구와 키워드 나열은 피합니다.",
          "대표 이미지는 고화질로 제품이 분명히 보이게 두고, 텍스트를 과하게 넣기보다 클릭을 유도할 정도로만 정리하는 편이 낫습니다.",
          "카테고리와 브랜드·색상·모델명 같은 속성값도 빠짐없이 맞춰야 합니다. 정보가 비어 있거나 카테고리가 어긋나면, 이후 유입을 넣어도 원하는 검색어에 잘 안 붙을 수 있습니다.",
        ],
      },
      {
        heading: "리뷰·체류·가격으로 인기도 쌓기",
        paragraphs: [
          "상품 정보가 맞아도 반응이 없으면 순위가 오래 버티기 어렵습니다. 리뷰 수와 평점, 포토리뷰, 판매 실적은 인기도의 핵심입니다.",
          "클릭률과 체류 시간도 중요합니다. 썸네일과 제목으로 관심을 끈 뒤, 상세페이지에서 제품 설명과 사용 장면을 빠르게 이해하게 만들어야 합니다.",
          "가격은 무조건 최저가만이 답이 아닙니다. 무료배송, 묶음 할인, 네이버 페이처럼 전환을 돕는 조건을 함께 맞춰 경쟁력을 만드는 쪽이 현실적입니다.",
        ],
      },
      {
        heading: "광고는 가속기, 데이터는 자산",
        paragraphs: [
          "신상품이나 신규 스토어는 자연 검색만으로 바로 상단에 오르기 어렵습니다. 이때 쇼핑검색광고나 검색 광고는 초기 노출과 반응 데이터를 빠르게 만드는 가속기 역할을 합니다.",
          "다만 광고 클릭만 늘리고 상세·혜택·CS가 약하면 전환이 남지 않습니다. 머무는 시간, 장바구니, 구매, 리뷰로 이어지는 흐름까지 같이 설계해야 광고비도 자산이 됩니다.",
          "예산은 처음부터 크게 쓰기보다, 소수 상품과 롱테일 키워드로 테스트한 뒤 반응 좋은 지점을 넓히는 방식이 리스크가 적습니다.",
        ],
      },
      {
        heading: "검색 유입이 반복되어야 순위가 유지됩니다",
        paragraphs: [
          "상품 최적화와 광고는 상위 노출의 출발점입니다. 그 위에서 목표 키워드로 실제 사용자가 상품 페이지를 찾아오는 방문이 반복되어야 순위가 유지됩니다.",
          "프로그램으로 방문 숫자만 채우는 방식은 최근 환경에서 부담이 커지고, 원하는 키워드 적합도를 만들기에도 불리합니다.",
          "결국 필요한 것은 검색 의도와 연결된, 실제 사용자의 방문입니다. 판매가 감당할 수 있는 범위에서 유입이 이어질수록 상위 자리가 안정됩니다.",
        ],
      },
      {
        heading: "올려줌을 써야 하는 이유",
        paragraphs: [
          "스마트스토어 상위 노출은 상품 세팅만으로 끝나지 않습니다. 정보가 맞아도, 목표 키워드로 실제 사용자가 들어오는 흐름이 없으면 순위는 쉽게 밀립니다.",
          "올려줌은 유입플처럼 프로그램으로 트래픽을 넣는 방식이 아니라, 자사 앱 실제 사용자가 상품 페이지를 방문하는 리워드 방식으로 순위를 만들고 유지합니다.",
          "목표 키워드, 하루 유입 수, 진행 기간을 직접 정해 등록할 수 있어, 상품 최적화와 광고로 만든 기반 위에 검색 유입을 꾸준히 쌓기에 적합합니다.",
          "상위 노출을 한 번에 끝내는 방법이 아니라, 검색에 잡히는 상품과 실제 방문이 함께 가는 구조를 만들 때 올려줌이 필요합니다.",
        ],
      },
    ],
  },
  {
    slug: "naver-shopping-keyword-analysis",
    title: "네이버 쇼핑 키워드 분석 하는 법, 상위 노출의 시작",
    description:
      "네이버 쇼핑 키워드 분석은 검색량·경쟁·연관어를 보고 상품명과 카테고리에 맞는 키워드를 고르는 일입니다. 파생 키워드, 연관어 분류, 카테고리 통일 방법과 올려줌 키워드 분석·리워드 활용까지 정리했습니다.",
    keywords:
      "네이버 쇼핑 키워드 분석, 네이버 키워드 분석, 스마트스토어 키워드 분석, 네이버 쇼핑 키워드, 키워드 분석 방법, 스마트스토어 상위 노출, 롱테일 키워드, 네이버 데이터랩",
    publishedAt: "2026-09-29",
    sections: [
      {
        heading: "네이버 쇼핑 키워드 분석이 매출을 가르는 이유",
        paragraphs: [
          "네이버 쇼핑 키워드 분석은 고객이 실제로 검색하는 말과 내 상품이 같은 자리에서 만나게 만드는 작업입니다.",
          "키워드는 그 연결고리입니다. 고객은 원하는 상품을 찾기 위해 특정 검색어를 쓰고, 네이버 쇼핑 결과에 뜬 상품을 비교한 뒤 구매합니다. 검색어와 상품이 어긋나면 클릭조차 잘 나지 않습니다.",
          "그래서 네이버 쇼핑 키워드 분석은 ‘요즘 잘 나가는 단어를 나열하는 일’이 아니라, 내 상품을 살 만한 사람이 실제로 치는 검색어를 찾아 상품명·태그·상세·광고에 맞게 배치하는 일입니다.",
        ],
      },
      {
        heading: "좋은 키워드의 조건: 검색량 · 경쟁 · 쇼핑 의도",
        paragraphs: [
          "네이버 쇼핑 키워드 분석에서 기본으로 보는 축은 검색 빈도와 관련 상품 수입니다. 검색은 많은데 경쟁이 상대적으로 낮은 쪽이 유리하고, 검색 자체가 너무 적으면 노출을 늘려도 구매로 이어지기 어렵습니다.",
          "대표 키워드(짧은 한 단어)는 검색량은 크지만 경쟁이 매우 세서, 초보 스토어가 바로 잡기 어려운 경우가 많습니다. 반면 세부 키워드·롱테일 키워드는 검색량은 작아도 구매 의도가 분명해 초기 유입과 전환에 유리한 경우가 많습니다.",
          "추가로, 해당 검색어를 쳤을 때 최상단에 쇼핑 영역이 뜨는지도 확인하면 좋습니다. 정보성 검색보다 쇼핑 의도가 강한 키워드가 판매와 더 잘 맞습니다.",
        ],
      },
      {
        heading: "팁 1. 동의어·오탈자 파생 키워드까지 챙기기",
        paragraphs: [
          "고객은 같은 상품을 여러 표현으로 검색합니다. 맞춤법이 다른 표기, 비슷한 의미의 동의어, 줄임말까지 실제 검색에 자주 섞입니다.",
          "네이버 광고의 키워드 도구나 쇼핑·통합검색의 자동완성·연관 검색어를 보면, 대표 키워드 주변으로 파생어가 얼마나 넓게 퍼져 있는지 파악할 수 있습니다.",
          "검색량이 의미 있는 파생어를 모아 두면, 상품명과 태그에 자연스럽게 녹여 노출 범위를 넓힐 수 있습니다. 다만 의미만 비슷하고 실제 상품과 무관한 단어는 적합도를 해칠 수 있어 걸러야 합니다.",
        ],
      },
      {
        heading: "팁 2. 연관 검색어는 세 가지로 나눠 쓰기",
        paragraphs: [
          "연관 검색어는 상품명, 상품 설명, 상세페이지에 바로 쓸 수 있는 재료입니다. 다만 모두 같은 자리에 넣기보다, 성격에 따라 나누는 편이 효율적입니다.",
          "쇼핑 키워드는 구매 목적이 분명한 검색어로, 내 상품 특징과 맞으면 상품명 앞쪽에 두기 좋습니다. 정보성 키워드는 사용법·효과·관리 같은 궁금증을 담은 검색어로, 상세페이지나 설명 문구에 담아 체류와 신뢰를 돕습니다.",
          "경쟁·브랜드성 키워드는 특정 브랜드나 경쟁 상품을 직접 겨냥한 검색어입니다. 상품명에 무작정 넣기보다, 경쟁 상품의 구성·가격·후기를 조사하는 용도로 쓰는 편이 안전합니다.",
        ],
      },
      {
        heading: "팁 3. 상품명 키워드는 카테고리를 맞추기",
        paragraphs: [
          "스마트스토어 상품명에는 글자 수 제한이 있어, 넣고 싶은 키워드를 전부 나열하기보다 우선순위를 정해야 합니다. 보통 핵심 키워드를 앞에 두고, 과장 문구와 중복 나열은 줄이는 편이 낫습니다.",
          "더 중요한 것은 상품명에 넣은 키워드들이 내 상품 카테고리와 맞는지입니다. 카테고리가 어긋난 키워드를 넣으면 적합도에서 불리해질 수 있습니다.",
          "확인 방법은 단순합니다. 네이버 쇼핑에서 쓰고 싶은 키워드를 검색해, 광고가 아닌 상위 상품의 카테고리가 내 상품과 같은지 비교합니다. 같은 계열이면 상품명에 쓰기 쉽고, 카테고리가 달라지면 상세·태그 쪽으로 돌리거나 제외하는 편이 낫습니다.",
        ],
      },
      {
        heading: "분석에 도움이 되는 네이버 기본 도구",
        paragraphs: [
          "네이버 데이터랩의 쇼핑인사이트에서는 카테고리·기간별 인기 검색어와 연령·성별 관심 흐름을 볼 수 있습니다. 시즌 키워드를 고를 때 특히 유용합니다.",
          "네이버 광고시스템의 키워드 도구에서는 연관 키워드와 검색·클릭·경쟁 정도를 함께 확인할 수 있습니다. 광고를 당장 집행하지 않아도, 키워드 후보를 걸러내는 기준으로 쓰기 좋습니다.",
          "여기에 통합검색·쇼핑 검색의 자동완성과 연관어를 더하면, 도구 수치와 실제 고객이 치는 표현을 함께 맞출 수 있습니다. 한 곳의 결과만 맹신하기보다 여러 신호를 교차 확인하는 편이 안전합니다.",
        ],
      },
      {
        heading: "키워드를 골랐다면, 상품과 유입까지 이어가기",
        paragraphs: [
          "좋은 키워드를 찾았다면 상품명·태그·속성·카테고리에 반영하고, 상세페이지에는 정보성 궁금증까지 자연스럽게 풀어 줍니다. 띄어쓰기 여부에 따라 검색 결과가 달라지는 경우도 있어, 등록 전 실제로 검색해 보는 습관이 필요합니다.",
          "다만 키워드 세팅만으로 상위가 바로 고정되지는 않습니다. 검색 결과에 노출된 뒤에도, 목표 키워드로 실제 사용자가 상품 페이지를 찾아오는 방문이 반복되어야 순위가 유지됩니다.",
          "프로그램으로 방문 숫자만 채우는 방식은 최근 환경에서 부담이 큽니다. 검색 의도와 연결된, 실제 사용자 방문이 쌓일수록 네이버 쇼핑 키워드 분석으로 만든 기반이 성과로 이어집니다.",
        ],
      },
      {
        heading: "올려줌에서 키워드 분석과 순위 상승을 이어가기",
        paragraphs: [
          "네이버 쇼핑 키워드 분석 후보를 매번 여러 사이트에서 따로 모아 정리하기 어렵다면, 올려줌의 키워드 분석 탭에서 검색어를 바로 살펴볼 수 있습니다. 분석한 키워드를 상품 전략에 바로 연결하기 쉬운 구조입니다.",
          "키워드를 골랐다면, 그다음 단계는 해당 검색어로 실제 사용자가 상품을 찾아오게 만드는 일입니다. 올려줌은 고품질 리워드로 실제 사용자 방문을 만들어, 목표 키워드의 순위 상승을 자연스럽게 돕습니다.",
          "키워드 분석으로 ‘어디에 노출될지’를 정하고, 리워드로 ‘그 자리에서 반복 방문이 생기게’ 만드는 흐름이 맞춰질 때 스마트스토어 상위 노출이 오래 갑니다.",
        ],
      },
    ],
  },
];

export const getGuidePost = (slug) =>
  GUIDE_POSTS.find((post) => post.slug === slug) || null;

export const getGuidePostUrl = (slug) => `${SITE_ORIGIN}/guide/${slug}`;

export const GUIDE_INDEX_URL = `${SITE_ORIGIN}/guide`;
